// extracted by mini-css-extract-plugin
export var colorSquare = "_sb-0";
export var danger = "_sb-5";
export var lightPink = "_sb-8";
export var neutralBlue = "_sb-7";
export var neutralYellow = "_sb-6";
export var normal = "_sb-1";
export var primary = "_sb-2";
export var primaryLight = "_sb-3";
export var solidBlack = "_sb-g";
export var solidGreen = "_sb-b";
export var solidLightBlue = "_sb-d";
export var solidNavy = "_sb-c";
export var solidOrange = "_sb-f";
export var solidPink = "_sb-e";
export var solidRed = "_sb-9";
export var solidYellow = "_sb-a";
export var success = "_sb-4";